
import "./Input.css";
import { Input, InputNumber } from "antd";

const CustomInput = ({
  className = "",
  type = "text",
  placeholder = "",
  value,
  onChange,
  onPressEnter,
  icon = null,
  style ={},
  isNumber = false,
  min,
  max,
  isPassword,
  ...props
}) => {
  if (isNumber) {
    return (
      <InputNumber
        placeholder={placeholder}
        value={value}
        style={{ width: '100%', ...style }}
        className={`custom-input ${className}`}
        onChange={onChange}
        min={min}
        max={max}
        {...props}
      />
    );
  }
  
  if (isPassword) {
    return (
      <Input.Password
        placeholder={placeholder}
        value={value}
        style={style}
        className={`custom-input ${className}`}
        onChange={onChange}
        onPressEnter={onPressEnter}
        {...props}
      />
    );
  }
  return (

      <Input
        type={type}
        placeholder={placeholder}
        value={value}
        style={style}
         suffix={icon}
        className={`custom-input ${className}`} 
        onChange={onChange}
          onPressEnter={onPressEnter}
        {...props}
      />

  );
};

export default CustomInput;
